export enum VendorListName {
    SIRDATA = "SIRDATA"
}
